import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import Display from "@/pages/Display";
import Report from "@/pages/Report";
import Calendar from "@/pages/Calendar";
import Login from "@/pages/Login";
import Security from "@/pages/Security";
import { AuthGate } from "@/components/AuthGate";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/display" element={<Display />} />
        <Route path="/" element={<AuthGate><Dashboard /></AuthGate>} />
        <Route path="/calendario" element={<AuthGate><Calendar /></AuthGate>} />
        <Route path="/report" element={<AuthGate><Report /></AuthGate>} />
        <Route path="/impostazioni/sicurezza" element={<AuthGate><Security /></AuthGate>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
